import { lazy } from 'react';
const WaybillForm = lazy(() =>
  import('../features/waybill-form/ui/WaybillForm').then((module) => ({
    default: module.WaybillForm,
  }))
);
const WybillPDF = lazy(() =>
  import('../features/waybill-form/ui/WybillPDF').then((module) => ({
    default: module.WybillPDF,
  }))
);
// ESLATMA PERMISSION BERILADIGAN JOYDA, RATHNING / DAN KEYINGI BIRINCHI QIYMATI PERMISION STRING ICHIDA BOLISHI SHART
const routes = [
  {
    path: '/',
    component: lazy(() => import('../pages/Dashboard')),
    meta: {
      title: 'Corporate Profile',
      icon: 'DashboardIcon',
      permission: 'seller/user/me',
    },
  },
  {
    path: '/rfp',
    component: lazy(() => import('../pages/Rfp')),
    meta: {
      title: 'RFP’s',
      icon: 'ShoppingOutlined',
      permission: 'seller/rfp/index',
    },
    noSub: true,
    children: [
      {
        path: '/rfp/:id',
        component: lazy(() => import('../pages/Rfp/Details')),
      },
    ],
  },
  {
    path: '/order',
    component: lazy(() => import('../pages/Orders')),
    meta: {
      title: 'Orders',
      icon: 'ShoppingIcon',
      permission: 'seller/order/index',
    },
    noSub: true,
    children: [
      {
        path: '/order/:orderId',
        component: lazy(() => import('../pages/Orders/Details')),
      },
      {
        path: '/order/waybill/new',
        component: WaybillForm,
      },
      {
        path: '/order/waybill/view',
        component: WybillPDF,
      },
    ],
  },
  {
    path: '/products',
    component: lazy(() => import('../pages/Products')),
    meta: {
      title: 'Products',
      icon: 'ProductIcon',
      permission: 'seller/element/index',
    },
    noSub: true,

    children: [
      {
        path: '/products/:id',
        component: lazy(() => import('../pages/Products/Preview')),
      },
    ],
  },
  // {
  //   path: "/documents",
  //   component: lazy(() => import("../pages/Documents")),
  //   meta: {
  //     title: "Documents",
  //     icon: "FileOutlined",
  //     permission: "staff",
  //   },

  // },
  {
    path: '/settings/warehouse',
    component: lazy(() => import('../pages/Settings/Warehouse')),
    meta: {
      title: 'Settings',
      icon: 'SettingOutlined',
      permission: 'seller/warehouse/index',
    },
    children: [
      {
        path: '/warehouse',
        component: lazy(() => import('../pages/Settings/Warehouse')),
        meta: {
          title: 'Warehouse',
          icon: '',
          permission: 'seller/warehouse/index',
        },
      },
      {
        path: '/staff',
        component: lazy(() => import('../pages/Settings/Staff')),
        meta: {
          title: 'Staff',
          icon: '',
          permission: 'seller/staff/index',
        },
      },
      {
        path: '/couriers',
        component: lazy(() => import('../pages/Settings/Couriers')),
        meta: {
          title: 'Couriers',
          icon: '',
          permission: 'seller/couriers/index',
        },
      },
      {
        path: '/cars',
        component: lazy(() => import('../pages/Settings/Cars')),
        meta: {
          title: 'Cars',
          icon: '',
          permission: 'seller/car/index',
        },
      },
    ],
  },
];

export default routes;
